interface CalendarSync {
  sub?: string | null
}

export const isConnected = (calendarSync: CalendarSync) => !!calendarSync.sub
